import ApiService from './api.service'

const PublicService = {

  postAction (action, params) {
    return ApiService.post(`public/${action}`, params)
  },
  /***
   * Get available plans based on lat/lng
   * @param {number} params.lat latitude of point
   * @param {number} params.lng latitude of point
   * @param {number} params.place_id google place_id can be a substitute
   * @param {string} params.rowkey unique rowkey of a location in database
   * @param {string} params.email_address latitude of point
   * @returns {*}
   */
  getAvailablePlans (params) {
    return ApiService.query('public/available-plans', params)
  },
  /***
   * Get email unique status from API
   * @param {string} params.email_address of user trying to sign up account
   * @returns {*}
   */
  getEmailUnique (params) {
    return ApiService.query('public/email-unique', params)
  },
  /***
   * Get nm batch report
   * @returns {*}
   */
  getNmBatch (batchKey) {
    return ApiService.get('entrance/nm-batch', batchKey)
  },
  /***
   * Get all plans in catalog
   * @returns {*}
   */
  getPlans () {
    return ApiService.get('public', 'plans')
  },
  /***
   * Register a user account with a unique email address
   * @param {string} params.email_address email address of the user we are creating
   * @param {string} params.mobile_number mobile phone number for SMS/calls
   * @param {string} params.phone_number phone number to call the user
   * @param {string} params.password
   * @param {string} params.first_name
   * @param {string} params.last_name
   * @param {boolean} params.opt_in_sms
   * @param {boolean} params.opt_in_email
   * @returns {*}
   */
  registerUser (params) {
    return this.postAction('register', params)
  },

  /***
   * Request password reset be sent to email_address
   * @param {string} params.email_address email address of the user we are creating
   * @returns {*}
   */
  requestPasswordReset (params) {
    return this.postAction('request-password-reset', params)
  },
  /***
   * Commit password reset with token and new password
   * @param {string} params.email_address email address of the user we are creating
   * @param {string} params.token token authenticating password reset request
   * @param {string} params.password new password to set
   * @returns {*}
   */
  commitPasswordReset (params) {
    return this.postAction('commit-password-reset', params)
  },
}
export default PublicService
